// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"banner_titleContainer__Zr_fL","title":"banner_title__y9TLp"};